export const URL_STATE_PREFIX = {
  RIGHT_RAIL: 'pane',
  SHAREABLE: 'shareable'
}
